var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlanBronze = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "46px",
    viewBox: "0 0 40 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.000000, -422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.000000, 383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.000000, 38.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CDDBFF",
    fillRule: "nonzero",
    cx: 20,
    cy: 29.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3F3F1",
    fillRule: "nonzero",
    cx: 21,
    cy: 30.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2352941,30.5 C17.2352941,27.3898462 19.2428235,24.7858462 22,23.8726154 C21.3287059,23.6507692 20.6256471,23.5 19.8823529,23.5 C16.0811765,23.5 13,26.6338462 13,30.5 C13,34.3661538 16.0811765,37.5 19.8823529,37.5 C20.6256471,37.5 21.3287059,37.3492308 22,37.1273846 C19.2428235,36.2141538 17.2352941,33.6101538 17.2352941,30.5 L17.2352941,30.5 Z",
    fill: "#CDDBFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.137931,29.5 C10.137931,22.53136 14.8448276,16.77008 21,15.69488 C20.3255172,15.57616 19.6365517,15.5 18.9310345,15.5 C11.7889655,15.5 6,21.76752 6,29.5 C6,37.23248 11.7889655,43.5 18.9310345,43.5 C19.6365517,43.5 20.3255172,43.4216 21,43.30512 C14.8448276,42.22992 10.137931,36.46864 10.137931,29.5 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6825499,18.5 L0.215234198,2.9710623 C-0.0803499206,2.45329475 -0.0711129169,1.82664046 0.240635958,1.3199838 C0.552384833,0.811104966 1.12046056,0.5 1.73241205,0.5 L12.1240412,0.5 C12.738302,0.5 13.3086869,0.813327144 13.6181266,1.32442816 L25,15.2867301 L20.8754657,15.9123178 L11.1310633,3.83326749 L4.66516073,3.83326749 L14.7169056,16.8911429 L11.6825499,18.5 Z",
    fill: "#0049FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8863847,18.5 L25.9914643,16.8911429 L35.5458239,3.83326749 L29.3965985,3.83326749 L20.7874524,15.1333109 L19,11.3979181 L26.975713,1.35776083 C27.271158,0.828882392 27.8245663,0.5 28.4242756,0.5 L38.3459373,0.5 C38.9302129,0.5 39.4725971,0.811104966 39.7702469,1.3199838 C40.0678968,1.82664046 40.076716,2.45551693 39.7944999,2.9710623 L28.8863847,18.5 Z",
    fill: "#0049FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,46.5 C11.9528571,46.5 5,39.3228571 5,30.5 C5,21.6771429 11.9528571,14.5 20.5,14.5 C29.0471429,14.5 36,21.6771429 36,30.5 C36,31.7045714 35.8693571,32.9091429 35.6125,34.0748571 L32.373,33.3137143 C32.5767143,32.3971429 32.6785714,31.4508571 32.6785714,30.5 C32.6785714,23.5674286 27.2159286,17.9285714 20.5,17.9285714 C13.7840714,17.9285714 8.32142857,23.5674286 8.32142857,30.5 C8.32142857,37.4325714 13.7840714,43.0714286 20.5,43.0714286 C24.3838571,43.0714286 27.9444286,41.2245714 30.2716429,38.0062857 L32.9332143,40.0542857 C30.0192143,44.0908571 25.3714286,46.5 20.5,46.5 Z",
    fill: "#0049FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0049FF",
    cx: 21,
    cy: 30.5,
    r: 7
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlanBronze, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plan-bronze.66a76143.svg";
export { ForwardRef as ReactComponent };